import { getOperations } from "../../../services/api-server/operations";
import { getRigList } from "../../../services/api-server/rig";

export async function fetchAcrossOperatorsByIds<T>(
	operators: string[],
	ids: any[],
	fetcher: (operator: string, ids: any[]) => Promise<T[] | null>
): Promise<T[]> {
	if (!operators?.length) return [];
	if (operators.length === 1) {
		const res = await fetcher(operators[0], ids);
		return (res ?? []).filter(Boolean) as T[];
	}
	const results = await Promise.all(operators.map((op) => fetcher(op, ids)));
	return results.flat().filter(Boolean) as T[];
}

export async function fetchAcrossOperatorsNoIds<T>(
	operators: string[],
	fetcher: (operator: string) => Promise<T[] | null>
): Promise<T[]> {
	if (!operators?.length) return [];
	if (operators.length === 1) {
		const res = await fetcher(operators[0]);
		return (res ?? []).filter(Boolean) as T[];
	}
	const results = await Promise.all(operators.map((op) => fetcher(op)));
	return results.flat().filter(Boolean) as T[];
}

export function createOperationFetchWithRig(operators: string[]) {
	return async (ids: any[]) => {
		const operations = await fetchAcrossOperatorsByIds(
			operators,
			ids,
			(op, ids) =>
				getOperations(op, { _id: { $in: ids } }) as Promise<any[] | null>
		);

		const rigNames = [
			...new Set(operations.map((op: any) => op?.rig).filter(Boolean)),
		];

		const rigs =
			rigNames.length > 0
				? ((await getRigList({
						rig_name: { $in: rigNames },
					})) as any[] | null)
				: [];

		const rigMap = new Map(
			(rigs ?? []).map((rig: any) => [rig?.rig_name, rig])
		);

		return operations.map((op: any) => ({
			...op,
			rig_info: rigMap.get(op?.rig) ?? null,
		}));
	};
}
